import classNames from 'classnames';
import type { NumberRange } from 'shared/lib/time-ranges';

interface ProgressBarProps {
  sections: boolean[];
  percentage: NumberRange<0, 100>;
}

export function ProgressBar({ sections, percentage }: ProgressBarProps) {
  return (
    <div className="flex items-baseline justify-center gap-2">
      <div className="flex w-[424px] gap-2">
        {sections.map((section, idx) => (
          <span
            className={classNames('h-1 w-full rounded-sm', section ? 'bg-deep-green-600' : 'bg-slate-50')}
            key={idx}
          />
        ))}
      </div>
      <span className="text-sm font-medium text-slate-500">{percentage} %</span>
    </div>
  );
}
